import React, { useState, useEffect, useRef } from "react";
import apiClient from "../apiClient";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from 'react-icons/fa';
import { useShop } from '../context/ShopContext';
import Sidebar from "./Sidebar";
import "./parchaTable.css";

/* ── Invoice Details: per-Receive-Type field configuration ──
   Add a new Receive Type by adding one entry here — no if-else needed elsewhere. */
const normReceiveType = (t) => (t || "").replace(/\s+/g, "").toUpperCase();
const STANDARD_INVOICE_FIELDS = [
  { key: "transactionNo", label: "Transaction No" },
  { key: "invoiceAmt", label: "Invoice Amount" },
  { key: "exciseDuty", label: "Guarantee Fulfilled" },
  { key: "labourCharge", label: "Guarantee %" },
  { key: "tds", label: "TDS" },
];
const INVOICE_SECTION_FIELDS = {
  RSBCL: STANDARD_INVOICE_FIELDS,
  XPARTY: STANDARD_INVOICE_FIELDS,
};



const EditStockDate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [date, setDate] = useState(localStorage.getItem("sip_date_eng_aamad") || new Date().toISOString().split("T")[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shopId, setShopId] = useState(null);
  const [tokenString, setToken] = useState(null);
  const [shopName, setshopName] = useState(null);
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [partyType, setPartyType] = useState("");

  const inputRefs = useRef([]);
  const [apiConditionMet, setApiConditionMet] = useState(null);
  const [shopOptions, setShopOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rsbclData, setRsbclData] = useState(null);
  const [transactionNo, setTransactionNo] = useState("");
  const { userId, companyId } = useShop();
  const [receiveType, setReceiveType] = useState("");
  const [selectedTypeName, setSelectedTypeName] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [shop, setShop] = useState("");
  const [partyMaster, setPartyMaster] = useState("");
  const [receiveTypes, setReceiveTypes] = useState([]);
  const [shops, setShops] = useState([]);
  const [partyMasters, setPartyMasters] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [remark, setRemark] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [shopCodes, setShopCodes] = useState([]);
  const [selectedShopCode, setSelectedShopCode] = useState("");
  const [selectedShopCodeId, setSelectedShopCodeId] = useState("");

  const [catFilter, setCatFilter] = useState("");
  const [showEnteredOnly, setShowEnteredOnly] = useState(false);

  /* ── Invoice Details ── */
  const [invoiceAmt, setInvoiceAmt] = useState("");
  const [labourCharge, setLabourCharge] = useState("");
  const [exciseDuty, setExciseDuty] = useState("");
  const [tds, setTds] = useState("");
  const [otherCharges, setOtherCharges] = useState("");
  const [invRemarks, setInvRemarks] = useState("");
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [savedInvoiceData, setSavedInvoiceData] = useState(null);

  const netInvoiceCost = (
    (parseFloat(invoiceAmt) || 0) +
    (parseFloat(labourCharge) || 0) +
    (parseFloat(exciseDuty) || 0) +
    (parseFloat(otherCharges) || 0) -
    (parseFloat(tds) || 0)
  );

  /* Guarantee % = Guarantee Fulfilled (Excise Duty) ÷ Invoice Amount × 100 */
  const guaranteePercent = parseFloat(invoiceAmt) > 0
    ? ((parseFloat(exciseDuty) || 0) / parseFloat(invoiceAmt)) * 100
    : 0;

  /* ── Invoice Details: values/setters keyed to match INVOICE_SECTION_FIELDS ── */
  const invoiceFieldValues = {
    transactionNo: { value: transactionNo, readOnly: true },
    invoiceAmt: { value: invoiceAmt, onChange: setInvoiceAmt },
    exciseDuty: { value: exciseDuty, onChange: setExciseDuty },
    tds: { value: tds, onChange: setTds },
    labourCharge: { value: guaranteePercent.toFixed(2), readOnly: true },
  };
  const activeInvoiceFields = INVOICE_SECTION_FIELDS[normReceiveType(selectedTypeName)] || [];

  /* ── Mobile-only state ── */
  const [expandedCats, setExpandedCats] = useState({});
  const [mobileSelectedVar, setMobileSelectedVar] = useState({});



  const showToast = (message, type = "error") => {
    toast.dismiss();
    if (type.toLowerCase() === "error") {
      toast.error(message);
    } else if (type.toLowerCase() === "success") {
      toast.success(message);
    }
  };



  useEffect(() => {
    const savedShopId = localStorage.getItem("shopId");
    const savedTokenString = localStorage.getItem("tokenString");
    const savedshopName = localStorage.getItem("shopName");
    if (savedShopId && savedTokenString && savedshopName) {
      setShopId(savedShopId);
      setToken(savedTokenString);
      setshopName(savedshopName);
    } else {
      showToast("Please log in first!", "error");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (shopId && tokenString && shopName) {
      if (selectedTypeName === "SHOP" && !shop) return;
      fetchStock();
    }
  }, [shopId, tokenString, shopName, date, selectedTypeName, shop]);


  useEffect(() => {
    if (searchQuery.trim()) {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  }, [searchQuery, products]);



  const fetchStock = async () => {
    setLoading(true);
    setError(null);
    try {
      const isShopType = selectedTypeName === "SHOP";
      const response = await apiClient.post(
        isShopType ? "/Liquor/GetStockProductDataWithDate" : "/Liquor/GetProductDataWithDate",
        {
          shopId: isShopType ? shop : shopId,
          typeId: "1",
          stockDate: date || new Date().toISOString().split("T")[0],
        }
      );
      const fetchedProducts = response.data.data || [];
      const updatedProducts = (isShopType
        ? fetchedProducts.filter(product => (parseFloat(product.openingStock) || 0) + (parseFloat(product.receivedQty) || 0) > 0)
        : fetchedProducts
      ).map((product) => ({
        id: product.id,
        name: product.pName,
        cat: product.catName || product.categoryName || product.typeName || "General",
        selected: false,
        variants: [
          {
            volume: product.packing,
            rate: parseFloat(product.mrp),
            openingStock: parseFloat(product.openingStock || 0),
            receivedStock: "",
            transferStock: "",
            currentStock: "",
            isSubmitted: false,
          },
        ],
      }));
      setProducts(updatedProducts);
      setFilteredProducts(updatedProducts);
      setApiConditionMet(true);
    } catch (err) {
      setError("Error fetching stock data");
      console.error("Error fetching stock:", err);
      setApiConditionMet(false);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const fetchReceiveTypes = async () => {
      try {
        const response = await apiClient.post('/Liquor/GetRecTypeMst', { shopId, companyId });
        const options = response.data?.data?.map((item) => ({
          id: item.id, label: item.name, type: item.typeName, type1: item.type,
        }));
        setReceiveTypes(options);
      } catch (err) {
        console.error('Error fetching dropdown options:', err);
        showToast('Failed to load dropdown options.', "error");
      }
    };
    fetchReceiveTypes();
  }, []);

  useEffect(() => {
    const fetchPartyMasters = async () => {
      try {
        const response = await apiClient.post('/Liquor/GetPartyMaster', { companyId });
        const options = response.data?.data?.map((item) => ({ id: item.id, label: item.name }));
        setPartyMasters(options);
      } catch (err) {
        console.error('Error fetching party master options:', err);
        showToast('Failed to load party masters.', "error");
      }
    };
    fetchPartyMasters();
  }, []);

  useEffect(() => {
    const fetchShopOptions = async () => {
      try {
        const response = await apiClient.post('/Liquor/GetShopMaster', { userId, companyId });
        const options = response.data?.data?.map((item) => ({ id: item.id, label: item.name }));
        setShopOptions(options);
        setIsLoading(false);
      } catch (err) {
        showToast('Failed to fetch shop options');
        setIsLoading(false);
      }
    };
    fetchShopOptions();
  }, []);



  const handleCheckboxChange = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) return prevSelected.filter(id => id !== productId);
      return [...prevSelected, productId];
    });
  };

  const handleReceivedStockChange = (productIndex, variantIndex, value) => {
    if (!selectedProducts.includes(filteredProducts[productIndex].id)) return;
    if (value === "") {
      const updatedProducts = [...filteredProducts];
      updatedProducts[productIndex].variants[variantIndex].receivedStock = "";
      setFilteredProducts(updatedProducts);
      return;
    }
    const numericValue = Number(value);
    if (numericValue < 0) {
      showToast("Negative values are not allowed!", "error");
      const updatedProducts = [...filteredProducts];
      updatedProducts[productIndex].variants[variantIndex].receivedStock = "";
      setFilteredProducts(updatedProducts);
      return;
    }
    const updatedProducts = [...filteredProducts];
    updatedProducts[productIndex].variants[variantIndex].receivedStock = numericValue;
    setFilteredProducts(updatedProducts);
  };

  /* ── Helper: sync a qty change to the master products array ── */
  const syncQtyToMaster = (productId, newQty, qtyField = "receivedStock") => {
    setProducts(prev => prev.map(p =>
      p.id === productId
        ? { ...p, variants: [{ ...p.variants[0], [qtyField]: newQty }] }
        : p
    ));
  };

  /* ── Mobile stepper (auto-selects product) ── */
  const handleMobileStepperChange = (productId, delta) => {
    const productIndex = filteredProducts.findIndex(p => p.id === productId);
    if (productIndex === -1) return;
    const product = filteredProducts[productIndex];
    const variant = product.variants[0];
    const currentQty = parseFloat(variant.receivedStock || 0);
    const newQty = Math.max(0, currentQty + delta);
    // Update filtered view immediately
    const updatedFiltered = [...filteredProducts];
    updatedFiltered[productIndex] = { ...product, variants: [{ ...variant, receivedStock: newQty }] };
    setFilteredProducts(updatedFiltered);
    // Sync to master so search re-filter preserves the qty
    syncQtyToMaster(productId, newQty, "receivedStock");
    if (newQty > 0 && !selectedProducts.includes(productId)) {
      setSelectedProducts(prev => [...prev, productId]);
    } else if (newQty === 0 && selectedProducts.includes(productId)) {
      setSelectedProducts(prev => prev.filter(id => id !== productId));
    }
  };

  const handleMobileQtySet = (productId, value) => {
    const newQty = Math.max(0, parseInt(value) || 0);
    const productIndex = filteredProducts.findIndex(p => p.id === productId);
    if (productIndex === -1) return;
    const product = filteredProducts[productIndex];
    const variant = product.variants[0];
    // Update filtered view immediately
    const updatedFiltered = [...filteredProducts];
    updatedFiltered[productIndex] = { ...product, variants: [{ ...variant, receivedStock: newQty }] };
    setFilteredProducts(updatedFiltered);
    // Sync to master so search re-filter preserves the qty
    syncQtyToMaster(productId, newQty, "receivedStock");
    if (newQty > 0 && !selectedProducts.includes(productId)) {
      setSelectedProducts(prev => [...prev, productId]);
    } else if (newQty === 0 && selectedProducts.includes(productId)) {
      setSelectedProducts(prev => prev.filter(id => id !== productId));
    }
  };

  const handleReceiveTypeChange = async (e) => {
    const selectedId = e.target.value;
    setReceiveType(selectedId);
    const selectedOption = receiveTypes.find((option) => option.id.toString() === selectedId);
    setSelectedTypeName(selectedOption ? selectedOption.type : "");
    setInvoiceNo("");
    setShop("");
    setPartyMaster("");
    setTransactionNo("");
    let apiType = selectedOption?.type1;
    try {
      const response = await apiClient.post(
        "/Liquor/GetTransactionNo",
        { type: apiType, companyId: companyId, typeId: "1" }
      );
      if (response.data?.code === 200 && response.data?.data) {
        setTransactionNo(response.data.data);
        showToast(`Transaction No. received!`, "success");
        if (selectedOption?.type === "RSBCL") {
          setShowPartyModal(true);
        }
        if (selectedOption?.type1 === "R") {
          setPartyType("");
        }
      } else {
        showToast("Invalid response from API!", "error");
      }
    } catch (err) {
      console.error("API Error:", err);
      showToast("Failed to fetch transaction number!", "error");
    }
  };

  useEffect(() => {
    if (selectedTypeName === "RSBCL" || selectedTypeName === "XParty") {
      const fetchShopCodes = async () => {
        try {
          const response = await apiClient.post("/Liquor/GetShopCodeData", { companyId: companyId });
          if (response.data && response.data.data) {
            setShopCodes(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching shop codes:", error);
        }
      };
      fetchShopCodes();
    }
  }, [selectedTypeName]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!receiveType) { showToast("Please select a Receive Type.", "error"); return; }
      if (selectedTypeName === "RSBCL" && (!invoiceNo || !remark)) {
        showToast("Invoice No. and Remark are required for RSBCL.", "error"); return;
      }
      if (selectedTypeName === "SHOP" && !shop) { showToast("Please select a Shop.", "error"); return; }
      if (selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && !partyMaster) {
        showToast("Please select a Party Master.", "error"); return;
      }
      if ((selectedTypeName === "RSBCL" || selectedTypeName === "XParty") && !selectedShopCodeId) {
        showToast("Shop Code is required!", "error"); return;
      }
      if (selectedProducts.length === 0) { showToast("Please select at least one product!", "error"); return; }
      for (const product of products) {
        if (selectedProducts.includes(product.id)) {
          let hasValidStock = product.variants.some((variant) => Number(variant.receivedStock || 0) > 0);
          if (!hasValidStock) { showToast(`Please enter received stock for ${product.name}!`, "error"); return; }
        }
      }
      const selectedData = products
        .filter((product) => selectedProducts.includes(product.id))
        .map((product) => ({
          ProductId: product.id,
          ReceivedHeadQty: product.variants.reduce((total, variant) => total + Number(variant.receivedStock || 0), 0),
        }));
      const finalInvoiceNo = invoiceNo?.trim() || "0";
      const finalPartyMaster = partyMaster || "0";
      const finalShop = shop || "0";
      const payload = {
        ReceivedHeadId: receiveType,
        ReceivedPartyId: finalPartyMaster,
        ReceivedShopId: finalShop,
        ShopId: shopId,
        StockDate: date || new Date().toISOString().split("T")[0],
        InvoiceNo: finalInvoiceNo,
        Remark: remark,
        TransactionNo: "0",
        TransactionNumber: transactionNo,
        receivedQtyDetails: selectedData,
        IsXparty: partyType,
        ShopCode: selectedShopCode || "0",
        ShopCodeId: selectedShopCodeId || "0",
        InvoiceAmount: parseFloat(invoiceAmt) || 0,
        LabourCharge: guaranteePercent || 0,
        ExciseDuty: parseFloat(exciseDuty) || 0,
        Tds: parseFloat(tds) || 0,
        OtherCharges: parseFloat(otherCharges) || 0,
        InvoiceRemark: invRemarks,
        NetInvoiceCost: netInvoiceCost,
        ReceiveType: selectedTypeName,
      };
      setLoading(true);
      let apiUrl = selectedTypeName === "SHOP"
        ? "/Liquor/SaveProductBulkReceivedDetailsStage"
        : "/Liquor/SaveBulkProductReceivedDetails";
      const response = await apiClient.post(apiUrl, payload);
      if (response.status === 200) {
        if (response.data && response.data.code !== 200) {
          showToast(response.data.data || "Negative stock not allowed!", "error");
        } else {
          showToast("Stock report submitted successfully!", "success");
          if (selectedTypeName === "RSBCL") {
            const submittedProds = products.filter(p => selectedProducts.includes(p.id));
            setSavedInvoiceData({ type:"RSBCL", transactionNo, invoiceNo, date, shopName, products: submittedProds.map(p=>({...p})), invoiceAmt, labourCharge, exciseDuty, tds, otherCharges, netInvoiceCost });
            setShowInvoiceModal(true);
          }
          setSelectedProducts([]);
          setInvoiceNo("");
          setRemark("");
          setShop("");
          setPartyMaster("");
          setReceiveType("");
          setTransactionNo("");
          setSelectedTypeName("");
          setSelectedShopCode("");
          setSelectedShopCodeId("");
          setInvoiceAmt(""); setLabourCharge(""); setExciseDuty(""); setTds(""); setOtherCharges(""); setInvRemarks("");
          const resetProducts = products.map(p => ({
            ...p,
            variants: p.variants.map(v => ({ ...v, receivedStock: "" }))
          }));
          setProducts(resetProducts);
          setFilteredProducts(resetProducts);
          fetchStock();
        }
      } else {
        showToast(`Error submitting stock report: ${response.statusText}`, "error");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      showToast(error.response?.data?.message || "Failed to submit data!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = () => {
    if (products.length === 0) { showToast("No product data available for preview!", "error"); return; }
    const editedProducts = products
      .map((product) => ({
        ...product,
        variants: product.variants.filter(variant => variant.receivedStock > 0)
      }))
      .filter(product => product.variants.length > 0);
    if (editedProducts.length === 0) {
      showToast("No Products Edited!", "error");
    } else {
      setPreviewData({ selectedProducts: editedProducts });
      setShowPreview(true);
    }
  };

  /* ── Mobile helpers ── */
  const toggleCat = (cat) => setExpandedCats(prev => ({ ...prev, [cat]: prev[cat] === false ? true : false }));
  const isCatExpanded = (cat) => expandedCats[cat] !== false;

  const buildMobileGroups = () => {
    const catOrder = [];
    const catMap = new Map();
    filteredProducts.forEach(product => {
      const cat = product.cat || "General";
      if (!catMap.has(cat)) { catMap.set(cat, new Map()); catOrder.push(cat); }
      const nameMap = catMap.get(cat);
      if (!nameMap.has(product.name)) nameMap.set(product.name, []);
      nameMap.get(product.name).push(product);
    });
    return catOrder.map(cat => {
      const nameMap = catMap.get(cat);
      const groups = [];
      nameMap.forEach((prods, name) => groups.push({ name, products: prods }));
      return { cat, groups };
    });
  };

  const totalReceiveQty = products.reduce(
    (s, p) => s + p.variants.reduce((vs, v) => vs + Number(v.receivedStock || 0), 0), 0
  );
  const enteredCount = products.filter(p => p.variants.some(v => Number(v.receivedStock || 0) > 0)).length;
  const totalReceiveValue = products.reduce((s, p) => s + p.variants.reduce((vs, v) => vs + Number(v.receivedStock || 0) * Number(v.rate || 0), 0), 0);

  /* ══════════════════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════════════════ */
  return (
    <>
      <ToastContainer />

      {/* ═══ DESKTOP LAYOUT ═══════════════════════════════ */}
      <div className="amad-desktop-content">
        <div className="amad-desk-filter-bar">
          <div className="amad-desk-filter-grid">
            <div className="amad-desk-filter-field">
              <label>Search Products</label>
              <div className="amad-desk-filter-inp-wrap">
                <span className="amad-desk-filter-ico">🔍</span>
                <input type="text" placeholder="Search by product name..."
                  value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
              </div>
            </div>
            <div className="amad-desk-filter-field">
              <label>Select Date</label>
              <input type="date" value={date} max={new Date().toISOString().split("T")[0]}
                onChange={e => { setDate(e.target.value); localStorage.setItem("sip_date_eng_aamad", e.target.value); }} />
            </div>
            <div className="amad-desk-filter-field">
              <label>Receive Type</label>
              <select value={receiveType} onChange={handleReceiveTypeChange}>
                <option value="">Select receive type...</option>
                {receiveTypes.filter(opt => opt.label !== "RSGSM").map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
              </select>
            </div>
            {selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && (
              <div className="amad-desk-filter-field">
                <label>Party Master</label>
                <select value={partyMaster} onChange={e => setPartyMaster(e.target.value)}>
                  <option value="">Select party master...</option>
                  {partyMasters.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}
                </select>
              </div>
            )}
            {selectedTypeName === "SHOP" && (
              <div className="amad-desk-filter-field">
                <label>Shop</label>
                <select value={shop} onChange={e => setShop(e.target.value)}>
                  <option value="">Select Shop</option>
                  {shopOptions.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
                </select>
              </div>
            )}
          </div>
          {selectedTypeName === "RSBCL" && (
            <div className="amad-desk-filter-extra">
              <div className="amad-desk-filter-field">
                <label>Invoice No.</label>
                <input type="text" placeholder="Enter Invoice No." value={invoiceNo}
                  onChange={e => setInvoiceNo(e.target.value)} />
              </div>
              <div className="amad-desk-filter-field">
                <label>Remark</label>
                <input type="text" placeholder="Enter Remark" value={remark}
                  onChange={e => setRemark(e.target.value)} />
              </div>
              <div className="amad-desk-filter-field">
                <label>Shop Code</label>
                <select value={selectedShopCodeId} onChange={e => {
                  const id = e.target.value;
                  setSelectedShopCodeId(id);
                  const obj = shopCodes.find(s => s.id.toString() === id);
                  setSelectedShopCode(obj?.licenseNameCode || "");
                }}>
                  <option value="">-- Select Shop Code --</option>
                  {shopCodes.map(s => <option key={s.id} value={s.id}>{s.licenseNameCode}</option>)}
                </select>
              </div>
            </div>
          )}
          {selectedTypeName === "XParty" && (
            <div className="amad-desk-filter-extra">
              <div className="amad-desk-filter-field">
                <label>Shop Code</label>
                <select value={selectedShopCodeId} onChange={e => {
                  const id = e.target.value;
                  setSelectedShopCodeId(id);
                  const obj = shopCodes.find(s => s.id.toString() === id);
                  setSelectedShopCode(obj?.licenseNameCode || "");
                }}>
                  <option value="">-- Select Shop Code --</option>
                  {shopCodes.map(s => <option key={s.id} value={s.id}>{s.licenseNameCode}</option>)}
                </select>
              </div>
            </div>
          )}
          {activeInvoiceFields.length > 0 && (
            <div style={{margin:"12px 0 0 0",padding:"14px 16px",background:"#F8F5F7",border:"1px solid #E9D5E3",borderRadius:10}}>
              <div style={{fontWeight:700,fontSize:13,color:"#6D214F",marginBottom:10,letterSpacing:0.3}}>Invoice Details</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:"10px 14px"}}>
                {activeInvoiceFields.map(({key,label})=>{
                  const f = invoiceFieldValues[key];
                  return (
                    <div key={key}>
                      <label style={{fontSize:11,color:"#6B7280",fontWeight:600,display:"block",marginBottom:3}}>{label}</label>
                      {f.readOnly
                        ? <input type="text" value={f.value || ""} disabled
                            style={{width:"100%",padding:"5px 8px",border:"1px solid #D1D5DB",borderRadius:6,fontSize:13,background:"#F3F4F6",color:"#374151"}} />
                        : <input type="number" min="0" value={f.value} onChange={e=>f.onChange(e.target.value)}
                            placeholder="0"
                            style={{width:"100%",padding:"5px 8px",border:"1px solid #D1D5DB",borderRadius:6,fontSize:13}} />}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {transactionNo && <div className="amad-desk-txn-badge">Txn: {transactionNo}</div>}
        </div>

        {apiConditionMet === true && (
          <div className="amad-desk-stat-bar">
            <div className="amad-desk-stat-card">
              <div className="amad-desk-stat-num">{products.length}</div>
              <div className="amad-desk-stat-lbl">TOTAL PRODUCTS</div>
            </div>
            <div className="amad-desk-stat-card grn">
              <div className="amad-desk-stat-num">{enteredCount}</div>
              <div className="amad-desk-stat-lbl">ENTERED</div>
            </div>
            <div className="amad-desk-stat-card">
              <div className="amad-desk-stat-num">{totalReceiveQty}</div>
              <div className="amad-desk-stat-lbl">TOTAL QTY</div>
            </div>
            <div className="amad-desk-stat-card">
              <div className="amad-desk-stat-num">₹{totalReceiveValue.toLocaleString("en-IN")}</div>
              <div className="amad-desk-stat-lbl">TOTAL VALUE</div>
            </div>
            <button className={`amad-desk-entered-btn${showEnteredOnly ? ' active' : ''}`}
              onClick={() => setShowEnteredOnly(p => !p)}>
              {showEnteredOnly ? '✅ Entered Only' : 'Show Entered Only'}
            </button>
          </div>
        )}

        <div className="amad-desk-products">
          {apiConditionMet === null && (
            <div className="amad-desk-loading"><FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Loading stock data…</div>
          )}
          {apiConditionMet === false && <div className="amad-desk-empty">✅ Already Submitted Data</div>}
          {apiConditionMet === true && (() => {
            const allGroups = buildMobileGroups();
            let groups = catFilter ? allGroups.filter(g => g.cat === catFilter) : allGroups;
            if (showEnteredOnly) {
              groups = groups.map(g => ({
                ...g,
                groups: g.groups.filter(({ products: np }) => np.some(p => Number(p.variants[0]?.receivedStock || 0) > 0))
              })).filter(g => g.groups.length > 0);
            }
            return (<>
              <div className="amad-desk-cat-jumper">
                <button className={`amad-desk-cat-chip${!catFilter ? ' active' : ''}`} onClick={() => setCatFilter("")}>ALL <span className="amad-desk-cat-chip-count">{allGroups.reduce((s,g)=>s+g.groups.length,0)}</span></button>
                {allGroups.map(g => <button key={g.cat} className={`amad-desk-cat-chip${catFilter===g.cat?' active':''}`} onClick={() => setCatFilter(p=>p===g.cat?'':g.cat)}>{g.cat} <span className="amad-desk-cat-chip-count">{g.groups.length}</span></button>)}
              </div>
              {groups.length === 0
                ? <div className="amad-desk-empty" style={{color:"#6B7280"}}>No products found</div>
                : groups.map(({ cat, groups: nameGroups }) => {
              const expanded = isCatExpanded(cat);
              return (
                <div key={cat} className="amad-desk-cat-section">
                  <div className="amad-desk-cat-hdr" onClick={() => toggleCat(cat)}>
                    <div className="amad-desk-cat-hdr-left">
                      <span className="amad-desk-cat-name">{cat}</span>
                      <span className="amad-desk-cat-badge">{nameGroups.length} products</span>
                    </div>
                    <div className="amad-desk-cat-hdr-stats">
                      <span>CATEGORY QTY: <strong>{nameGroups.reduce((s, {products: np}) => s + np.reduce((ps, p) => ps + Number(p.variants[0]?.receivedStock || 0), 0), 0)}</strong></span>
                      <span>CATEGORY VALUE: <strong>₹{nameGroups.reduce((s, {products: np}) => s + np.reduce((ps, p) => { const v = p.variants[0]; return ps + Number(v?.receivedStock || 0) * Number(v?.rate || 0); }, 0), 0).toLocaleString("en-IN")}</strong></span>
                    </div>
                    <span className="amad-desk-cat-arrow">{expanded ? '▲' : '▼'}</span>
                  </div>
                  {expanded && (
                    <div className="amad-desk-cards-grid">
                      {nameGroups.map(({ name, products: nameProds }) => {
                        const hasAnyQty = nameProds.some(p => Number(p.variants[0]?.receivedStock || 0) > 0);
                        const bottleProds = nameProds.filter(p => !p.variants[0].volume.toUpperCase().includes('PET'));
                        const petProds = nameProds.filter(p => p.variants[0].volume.toUpperCase().includes('PET'));
                        return (
                          <div key={name} className={`amad-desk-product-card${hasAnyQty ? ' selected' : ''}`}>
                            <div className="amad-desk-card-toprow">
                              <span className="amad-desk-card-dot" />
                              <span className="amad-desk-card-pname2">{name}</span>
                              <span className="amad-desk-card-vbadge">{nameProds.length}v</span>
                            </div>
                            <div className="amad-desk-tbl-hdr">
                              <span className="amad-tdh amad-tdh-var">VARIANT</span>
                              <span className="amad-tdh amad-tdh-rate">RATE</span>
                              <span className="amad-tdh amad-tdh-stk">STOCK</span>
                              <span className="amad-tdh amad-tdh-qty">RECEIVE</span>
                            </div>
                            {bottleProds.length > 0 && (<>
                              <div className="amad-desk-sec-lbl">BOTTLE</div>
                              {bottleProds.map(p => {
                                const v = p.variants[0];
                                const rowQty = Number(v.receivedStock || 0);
                                return (
                                  <div key={p.id} className={`amad-desk-tbl-row${rowQty > 0 ? ' has-qty' : ''}`}>
                                    <span className="amad-tdc amad-tdc-var">{v.volume}</span>
                                    <span className="amad-tdc amad-tdc-rate">₹{Number(v.rate || 0).toLocaleString("en-IN")}</span>
                                    <span className="amad-tdc amad-tdc-stk">{v.openingStock}</span>
                                    <input type="number" inputMode="numeric" min="0"
                                      className="amad-tdc amad-tdc-inp"
                                      value={rowQty === 0 ? '' : rowQty} placeholder="0"
                                      onChange={e => handleMobileQtySet(p.id, e.target.value)}
                                      onBlur={e => { if (e.target.value === '') handleMobileQtySet(p.id, 0); }} />
                                  </div>
                                );
                              })}
                            </>)}
                            {petProds.length > 0 && (<>
                              <div className="amad-desk-sec-lbl pet">PET</div>
                              {petProds.map(p => {
                                const v = p.variants[0];
                                const rowQty = Number(v.receivedStock || 0);
                                return (
                                  <div key={p.id} className={`amad-desk-tbl-row${rowQty > 0 ? ' has-qty' : ''}`}>
                                    <span className="amad-tdc amad-tdc-var">{v.volume}</span>
                                    <span className="amad-tdc amad-tdc-rate">₹{Number(v.rate || 0).toLocaleString("en-IN")}</span>
                                    <span className="amad-tdc amad-tdc-stk">{v.openingStock}</span>
                                    <input type="number" inputMode="numeric" min="0"
                                      className="amad-tdc amad-tdc-inp"
                                      value={rowQty === 0 ? '' : rowQty} placeholder="0"
                                      onChange={e => handleMobileQtySet(p.id, e.target.value)}
                                      onBlur={e => { if (e.target.value === '') handleMobileQtySet(p.id, 0); }} />
                                  </div>
                                );
                              })}
                            </>)}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
            </>);
          })()}
        </div>


        <div className="amad-desk-footer">
          <div className="amad-desk-footer-stats">
            <span>SELECTED: <strong>{selectedProducts.length}</strong></span>
            <span className="amad-desk-footer-sep">|</span>
            <span>TOTAL QTY: <strong>{totalReceiveQty}</strong></span>
            <span className="amad-desk-footer-sep">|</span>
            <span>TOTAL VALUE: <strong>₹{totalReceiveValue.toLocaleString("en-IN")}</strong></span>
          </div>
          <div className="amad-desk-footer-actions">
            <button className="amad-desk-preview-btn" onClick={handlePreview}>Preview</button>
            <button className="amad-desk-submit-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? <><FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Submitting…</> : "Submit Report"}
            </button>
          </div>
        </div>
      </div>

      {/* ═══ MOBILE LAYOUT ════════════════════════════════ */}
      <div className="amad-mobile">
        {/* Header */}
        <div className="amad-mobile-header">
          <div className="amad-mobile-title">अंग्रेजी आमद</div>
          <div className="amad-mobile-subtitle">English Stock Inward / Receive Entry</div>
          {transactionNo && <div className="amad-mobile-txn">Txn: {transactionNo}</div>}
        </div>

        {/* Filters */}
        <div className="amad-filters">
          <div className="amad-filter-field">
            <label>Search Products</label>
            <div className="amad-filter-inp-wrap">
              <span className="amad-filter-ico">🔍</span>
              <input type="text" placeholder="Search by product name..."
                value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
            </div>
          </div>

          <div className="amad-filter-field">
            <label>Select Date</label>
            <div className="amad-filter-inp-wrap">
              <span className="amad-filter-ico">📅</span>
              <input type="date" value={date} max={new Date().toISOString().split("T")[0]}
                onChange={e => setDate(e.target.value)} />
            </div>
          </div>

          <div className="amad-filter-field">
            <label>Receive Type</label>
            <select value={receiveType} onChange={handleReceiveTypeChange}>
              <option value="">Select receive type...</option>
              {receiveTypes.filter(opt => opt.label !== "RSGSM").map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
            </select>
          </div>

          {selectedTypeName === "RSBCL" && (
            <>
              <div className="amad-filter-field amad-filter-full">
                <label>Invoice No.</label>
                <input type="text" placeholder="Enter Invoice No."
                  value={invoiceNo} onChange={e => setInvoiceNo(e.target.value)} />
              </div>
              <div className="amad-filter-field amad-filter-full">
                <label>Remark</label>
                <input type="text" placeholder="Enter Remark"
                  value={remark} onChange={e => setRemark(e.target.value)} />
              </div>
              {(selectedTypeName === "RSBCL" || selectedTypeName === "XParty") && (
                <div className="amad-filter-field amad-filter-full">
                  <label>Shop Code</label>
                  <select value={selectedShopCodeId} onChange={(e) => {
                    const selectedId = e.target.value;
                    setSelectedShopCodeId(selectedId);
                    const selectedObj = shopCodes.find(s => s.id.toString() === selectedId);
                    setSelectedShopCode(selectedObj?.licenseNameCode || "");
                  }}>
                    <option value="">-- Select Shop Code --</option>
                    {shopCodes.map(s => <option key={s.id} value={s.id}>{s.licenseNameCode}</option>)}
                  </select>
                </div>
              )}
            </>
          )}
          {activeInvoiceFields.length > 0 && (
            <div style={{margin:"8px 0 4px",padding:"14px",background:"#F8F5F7",border:"1px solid #E9D5E3",borderRadius:10,width:"100%"}}>
              <div style={{fontWeight:700,fontSize:13,color:"#6D214F",marginBottom:10,letterSpacing:0.3}}>Invoice Details</div>
              {activeInvoiceFields.map(({key,label})=>{
                const f = invoiceFieldValues[key];
                return (
                  <div key={key} style={{marginBottom:8}}>
                    <label style={{fontSize:11,color:"#6B7280",fontWeight:600,display:"block",marginBottom:3}}>{label}</label>
                    {f.readOnly
                      ? <input type="text" value={f.value || ""} disabled
                          style={{width:"100%",padding:"8px 10px",border:"1px solid #D1D5DB",borderRadius:6,fontSize:14,background:"#F3F4F6",color:"#374151"}} />
                      : <input type="number" min="0" value={f.value} onChange={e=>f.onChange(e.target.value)} placeholder="0"
                          style={{width:"100%",padding:"8px 10px",border:"1px solid #D1D5DB",borderRadius:6,fontSize:14}} />}
                  </div>
                );
              })}
            </div>
          )}

          {selectedTypeName === "SHOP" && (
            <div className="amad-filter-field amad-filter-full">
              <label>Shop</label>
              <select value={shop} onChange={e => setShop(e.target.value)}>
                <option value="">Select Shop</option>
                {shopOptions.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
              </select>
            </div>
          )}

          {selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && (
            <div className="amad-filter-field">
              <label>Party Master</label>
              <select value={partyMaster} onChange={e => setPartyMaster(e.target.value)}>
                <option value="">Select party master...</option>
                {partyMasters.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}
              </select>
            </div>
          )}
        </div>

        {/* Products area */}
        <div className="amad-products-area">
          {apiConditionMet === null && (
            <div className="amad-loading">
              <FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Loading stock data…
            </div>
          )}
          {apiConditionMet === false && <div className="amad-submitted">✅ Already Submitted Data</div>}
          {apiConditionMet === true && (() => {
            const allGroups = buildMobileGroups();
            const mobileGroups = catFilter ? allGroups.filter(g => g.cat === catFilter) : allGroups;
            return (<>
              <div className="amad-cat-jumper">
                <button className={`amad-cat-chip${!catFilter?' active':''}`} onClick={() => setCatFilter("")}>ALL <span className="amad-cat-chip-count">{allGroups.reduce((s,g)=>s+g.groups.length,0)}</span></button>
                {allGroups.map(g => <button key={g.cat} className={`amad-cat-chip${catFilter===g.cat?' active':''}`} onClick={() => setCatFilter(p=>p===g.cat?'':g.cat)}>{g.cat} <span className="amad-cat-chip-count">{g.groups.length}</span></button>)}
              </div>
              {mobileGroups.length === 0
                ? <div className="amad-submitted" style={{ color: "#6B7280" }}>No products found</div>
                : mobileGroups.map(({ cat, groups: nameGroups }) => {
              const expanded = isCatExpanded(cat);
              return (
                <div key={cat} className="amad-cat-section">
                  <div className="amad-cat-hdr" onClick={() => toggleCat(cat)}>
                    <div className="amad-cat-hdr-left">
                      <span className="amad-cat-name">{cat}</span>
                      <span className="amad-cat-badge">{nameGroups.length}</span>
                    </div>
                    <span className="amad-cat-arrow">{expanded ? '▲' : '▼'}</span>
                  </div>
                  {expanded && (
                    <div className="amad-cards-grid">
                    {nameGroups.map(({ name, products: nameProds }) => {
                    const hasAnyQty = nameProds.some(p => Number(p.variants[0]?.receivedStock || 0) > 0);
                    const bottleProds = nameProds.filter(p => !p.variants[0].volume.toUpperCase().includes('PET'));
                    const petProds = nameProds.filter(p => p.variants[0].volume.toUpperCase().includes('PET'));
                    const renderRows = plist => plist.map(p => {
                      const v = p.variants[0]; const recv = Number(v.receivedStock || 0);
                      return (
                        <div key={p.id} className="bx-row">
                          <span className="bx-col-var">{v.volume}</span>
                          <span className="bx-col">₹{Number(v.rate||0).toLocaleString('en-IN')}</span>
                          <span className="bx-col">{v.openingStock}</span>
                          <span className="bx-col-recv"><input type="number" min="0" value={recv===0?'':recv} placeholder="0" onChange={e=>handleMobileQtySet(p.id,e.target.value)} className={`bx-inp${recv>0?" on":""}`}/></span>
                        </div>
                      );
                    });
                    return (
                      <div key={name} className="bx-card">
                        <div className="bx-card-hdr">
                          <span className="bx-card-name"><span className={`bx-dot${hasAnyQty?" on":""}`}/>{name}</span>
                          <span className="bx-vcount">{nameProds.length}v</span>
                        </div>
                        <div className="bx-th-row">
                          <span className="bx-th">VARIANT</span>
                          <span className="bx-th" style={{textAlign:"center"}}>RATE</span>
                          <span className="bx-th" style={{textAlign:"center"}}>STOCK</span>
                          <span className="bx-th" style={{textAlign:"right"}}>RECEIVE</span>
                        </div>
                        {bottleProds.length>0 && <><div className="bx-sect bottle">BOTTLE</div>{renderRows(bottleProds)}</>}
                        {petProds.length>0 && <><div className="bx-sect pet">PET</div>{renderRows(petProds)}</>}
                        <div className="bx-footer">
                          <span>Total Received: <strong>{nameProds.reduce((s,p)=>s+Number(p.variants[0]?.receivedStock||0),0)}</strong></span>
                        </div>
                      </div>
                    );
                    })}
                    </div>
                  )}
                </div>
              );
            })}
            </>);
          })()}
        </div>


        {/* Sticky footer */}
        <div className="amad-sticky-footer">
          <div className="amad-footer-stats">
            <span>SELECTED ITEMS: <strong>{selectedProducts.length}</strong></span>
            <span>TOTAL RECEIVE QTY: <strong>{totalReceiveQty}</strong></span>
          </div>
          <div className="amad-footer-actions">
            <button className="amad-preview-btn" onClick={handlePreview}>
              Preview
            </button>
            <button className="amad-submit-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? <><FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Submitting…</> : "Submit Report"}
            </button>
          </div>
        </div>
      </div>

      {/* ═══ PREVIEW MODAL (React-controlled, category-wise) ══════════════════════ */}
      {showPreview && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 9999,
          background: "rgba(0,0,0,0.55)", backdropFilter: "blur(3px)",
          display: "flex", alignItems: "flex-start", justifyContent: "center",
          padding: "16px 12px", overflowY: "auto"
        }} onClick={e => { if (e.target === e.currentTarget) setShowPreview(false); }}>
          <div style={{
            background: "#fff", borderRadius: 14, width: "100%", maxWidth: "min(95vw, 680px)",
            boxShadow: "0 24px 64px rgba(0,0,0,0.28)", display: "flex", flexDirection: "column",
            maxHeight: "calc(100vh - 32px)"
          }}>
            <div style={{
              padding: "14px 18px", borderBottom: "1px solid #E5E7EB",
              display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0
            }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800, color: "#6D214F" }}>Preview — अंग्रेजी आमद</div>
                <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2 }}>
                  {(previewData?.selectedProducts || []).reduce((t, p) => t + p.variants.length, 0)} items selected
                </div>
              </div>
              <button onClick={() => setShowPreview(false)} style={{
                background: "#F3F4F6", border: "1px solid #E5E7EB", borderRadius: 8,
                padding: "8px 18px", fontSize: 13, fontWeight: 700, cursor: "pointer", color: "#374151",
                minWidth: 80, minHeight: 40
              }}>✕ Close</button>
            </div>
            <div style={{ flex: 1, overflowY: "auto", padding: "12px 16px 20px" }}>
              {(() => {
                const products = previewData?.selectedProducts || [];
                const catMap = new Map();
                products.forEach(p => {
                  const cat = p.cat || "General";
                  if (!catMap.has(cat)) catMap.set(cat, []);
                  catMap.get(cat).push(p);
                });
                return [...catMap.entries()].map(([cat, prods]) => (
                  <div key={cat} style={{ marginBottom: 16 }}>
                    <div style={{
                      fontSize: 10, fontWeight: 800, color: "#6D214F", textTransform: "uppercase",
                      letterSpacing: 1.5, padding: "5px 10px", background: "#FDF4F8",
                      borderRadius: 6, marginBottom: 6, display: "inline-block"
                    }}>{cat}</div>
                    {prods.map((product, pi) =>
                      product.variants.map((variant, vi) => (
                        <div key={`${pi}-${vi}`} style={{
                          display: "flex", justifyContent: "space-between", alignItems: "center",
                          padding: "10px 12px", borderBottom: "1px solid #F3F4F6"
                        }}>
                          <div style={{ flex: 1, minWidth: 0, paddingRight: 12 }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: "#111827",
                              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {product.name}
                            </div>
                            <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2 }}>
                              {variant.volume} &nbsp;·&nbsp; ₹{variant.rate}
                            </div>
                          </div>
                          <div style={{
                            background: "#ECFDF5", color: "#065F46", borderRadius: 20,
                            padding: "4px 14px", fontSize: 15, fontWeight: 800, flexShrink: 0
                          }}>{variant.receivedStock}</div>
                        </div>
                      ))
                    )}
                  </div>
                ));
              })()}
            </div>
          </div>
        </div>
      )}

      {/* Party type popup for RSBCL */}
      {showPartyModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Party Type</h5>
                <button type="button" className="btn-close" onClick={() => setShowPartyModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-check">
                      <input className="form-check-input" type="radio" name="partyType"
                        value="XParty" onChange={(e) => setPartyType(e.target.value)} />
                      <label className="form-check-label">X Party</label>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-check mt-2">
                      <input className="form-check-input" type="radio" name="partyType"
                        value="Shop" onChange={(e) => setPartyType(e.target.value)} />
                      <label className="form-check-label">Shop</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowPartyModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={() => {
                  if (!partyType) { showToast("Please select X Party or Shop", "error"); return; }
                  setShowPartyModal(false);
                }}>Confirm</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Generate Invoice Modal ── */}
      {showInvoiceModal && savedInvoiceData && (
        <div style={{position:"fixed",inset:0,zIndex:10000,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"16px 10px",overflowY:"auto"}}>
          <div style={{background:"#fff",borderRadius:14,width:"100%",maxWidth:640,boxShadow:"0 24px 64px rgba(0,0,0,0.28)"}}>
            <div id="invoice-print-area">
              <div style={{padding:"18px 24px",borderBottom:"1px solid #E5E7EB",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontSize:16,fontWeight:800,color:"#6D214F"}}>Purchase Invoice — {savedInvoiceData.type}</div>
                  <div style={{fontSize:11,color:"#6B7280",marginTop:3}}>
                    Txn: <strong>{savedInvoiceData.transactionNo}</strong> &nbsp;|&nbsp; Invoice: <strong>{savedInvoiceData.invoiceNo}</strong> &nbsp;|&nbsp; Date: <strong>{savedInvoiceData.date}</strong>
                  </div>
                </div>
                <button onClick={()=>setShowInvoiceModal(false)} style={{background:"#F3F4F6",border:"1px solid #E5E7EB",borderRadius:8,padding:"8px 14px",fontSize:13,fontWeight:700,cursor:"pointer",color:"#374151"}}>✕</button>
              </div>
              <div style={{maxHeight:"40vh",overflowY:"auto",padding:"0 24px"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,marginTop:12}}>
                  <thead>
                    <tr style={{background:"#FDF4F8"}}>
                      <th style={{textAlign:"left",padding:"8px 10px",borderBottom:"2px solid #E9D5E3",color:"#6D214F"}}>Product</th>
                      <th style={{textAlign:"right",padding:"8px 10px",borderBottom:"2px solid #E9D5E3",color:"#6D214F"}}>Variant</th>
                      <th style={{textAlign:"right",padding:"8px 10px",borderBottom:"2px solid #E9D5E3",color:"#6D214F"}}>Qty</th>
                      <th style={{textAlign:"right",padding:"8px 10px",borderBottom:"2px solid #E9D5E3",color:"#6D214F"}}>Rate</th>
                      <th style={{textAlign:"right",padding:"8px 10px",borderBottom:"2px solid #E9D5E3",color:"#6D214F"}}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {savedInvoiceData.products.map((p,i) =>
                      p.variants.filter(v=>Number(v.receivedStock||0)>0).map((v,j)=>(
                        <tr key={`${i}-${j}`} style={{borderBottom:"1px solid #F3F4F6"}}>
                          <td style={{padding:"8px 10px",fontWeight:500}}>{p.name}</td>
                          <td style={{padding:"8px 10px",textAlign:"right",color:"#6B7280"}}>{v.volume}</td>
                          <td style={{padding:"8px 10px",textAlign:"right",fontWeight:700}}>{v.receivedStock}</td>
                          <td style={{padding:"8px 10px",textAlign:"right"}}>₹{Number(v.rate||0).toLocaleString("en-IN")}</td>
                          <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600}}>₹{(Number(v.receivedStock||0)*Number(v.rate||0)).toLocaleString("en-IN")}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div style={{padding:"14px 24px",borderTop:"1px solid #E5E7EB",background:"#F8F5F7",marginTop:12}}>
                {[
                  {label:"Invoice Amount",val:savedInvoiceData.invoiceAmt},
                  {label:"Labour Charge",val:savedInvoiceData.labourCharge},
                  {label:"Excise Duty",val:savedInvoiceData.exciseDuty},
                  {label:"TDS (−)",val:savedInvoiceData.tds},
                  {label:"Other Charges",val:savedInvoiceData.otherCharges},
                ].filter(r=>parseFloat(r.val||0)>0).map(r=>(
                  <div key={r.label} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",fontSize:13}}>
                    <span style={{color:"#6B7280"}}>{r.label}</span>
                    <span style={{fontWeight:600}}>₹{Number(r.val||0).toLocaleString("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                  </div>
                ))}
                <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0 4px",borderTop:"2px solid #E9D5E3",marginTop:8,fontSize:15,fontWeight:800,color:"#6D214F"}}>
                  <span>Net Invoice Cost</span>
                  <span>₹{Number(savedInvoiceData.netInvoiceCost||0).toLocaleString("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                </div>
              </div>
            </div>
            <div style={{padding:"14px 24px",display:"flex",gap:10,borderTop:"1px solid #E5E7EB"}}>
              <button onClick={()=>window.print()} style={{flex:1,padding:"10px",background:"#6D214F",color:"#fff",border:"none",borderRadius:8,fontSize:14,fontWeight:700,cursor:"pointer"}}>Print Invoice</button>
              <button onClick={()=>setShowInvoiceModal(false)} style={{flex:1,padding:"10px",background:"#F3F4F6",color:"#374151",border:"1px solid #E5E7EB",borderRadius:8,fontSize:14,fontWeight:700,cursor:"pointer"}}>Close</button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </>
  );
};

export default EditStockDate;
